import { treaty } from '@elysiajs/eden';
import type { MarketFeedApp } from '@hypersense/market-feed';

import { env } from '../lib/env';
import { stripBodylessJsonContentType } from './stripBodylessJsonContentType';

const marketFeedBaseUrl = env.VITE_MARKET_FEED_BASE_URL;

export const marketFeedClient = treaty<MarketFeedApp>(marketFeedBaseUrl, {
  onRequest: stripBodylessJsonContentType,
  throwHttpError: false,
});

export type MarketFeedClientT = typeof marketFeedClient;

export function buildMarketFeedWebsocketUrl(input: { path: string }) {
  const websocketUrl = new URL(input.path, marketFeedBaseUrl);

  websocketUrl.protocol = websocketUrl.protocol === 'https:' ? 'wss:' : 'ws:';

  return websocketUrl.toString();
}
